import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
import { ImageUploaderProvider } from "components/ImageUploader/context/ImageUploaderContext";
import { GlobalSearchProvider } from "context/GlobalSearchContext/GlobalSearch";
import { WarehouseProvider } from "context/warehouseContext";
import { createBrowserHistory } from "history";
import ForgotPassword from "pages/Forgot-password";
import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import AuthRoute from "./components/AuthRoute";
import Auth from "./services/authentication";
import "react-table/react-table.css";
import "./App.scss";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import webSocket from "./services/webSocket";

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY);

const auth = new Auth();

window.onload = function () {
  setTimeout(() => {
    if (auth.isAuthenticated()) {
      let token = auth.getIdToken();
      webSocket.connect(token);
    }
  }, 2000);
};

const customHistory = createBrowserHistory();

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./pages/Login"));
const Register = React.lazy(() => import("./pages/Register"));
const NewWarehouse = React.lazy(() => import("./pages/NewWarehouse"));
const AccountTypes = React.lazy(() => import("./pages/AccountTypes"));
const AddWarehouseSite = React.lazy(() => import("./pages/AddWarehouseSite"));
const Page404 = React.lazy(() => import("./pages/Page404"));
const Page403 = React.lazy(() => import("./pages/Page403"));
const Page500 = React.lazy(() => import("./pages/Page500"));

const LoginInternal = React.lazy(() => import("./pages/LoginInternal"));
const LoginExternal = React.lazy(() => import("./pages/LoginExternal"));
const LoginExternalMFA = React.lazy(() => import("./pages/LoginExternal/MFA"));
const LoginExternalForgotPassword = React.lazy(() =>
  import("./pages/LoginExternal/ForgotPassword")
);
const LoginExternalResetPassword = React.lazy(() =>
  import("./pages/LoginExternal/ResetPassword")
);
const LoginExternalExpiredPassword = React.lazy(() =>
  import("./pages/LoginExternal/ExpiredPassword")
);
const LoginExternalPersonalDetails = React.lazy(() =>
  import("./pages/LoginExternal/PersonalDetails")
);

class App extends Component {
  render() {
    return (
      <Router history={customHistory}>
        <React.Suspense fallback={loading()}>
          <ImageUploaderProvider>
            <Switch>
              <>
                <Route
                  exact
                  path="/forgot-password"
                  name="Forgot Password"
                  render={(props) => <ForgotPassword {...props} />}
                />
                <Route
                  exact
                  path="/register"
                  name="Register Page"
                  render={(props) => <Register {...props} />}
                />
                <Route
                  exact
                  path="/new-warehouse"
                  name="New Warehouse"
                  render={(props) => <NewWarehouse {...props} />}
                />
                <Route
                  exact
                  path="/select-account-type"
                  name="Select Card"
                  render={(props) => <AccountTypes {...props} />}
                />
                <Route
                  exact
                  path="/add-site"
                  name="Add Site"
                  render={(props) => <AddWarehouseSite {...props} />}
                />
                <Route
                  exact
                  path="/404"
                  name="Page 404"
                  render={(props) => <Page404 {...props} />}
                />
                <Route
                  exact
                  path="/403"
                  name="Page 403"
                  render={(props) => <Page403 {...props} />}
                />
                <Route
                  exact
                  path="/500"
                  name="Page 500"
                  render={(props) => <Page500 {...props} />}
                />
                <Route
                  exact
                  path="/login"
                  name="Login"
                  render={(props) => <Login {...props} />}
                />
                <Route
                  exact
                  path="/login-internal"
                  name="Login Internal"
                  render={(props) => {
                    return <LoginInternal {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/login-external"
                  name="Login External"
                  render={(props) => {
                    return <LoginExternal {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/login-external/mfa"
                  name="Login External - MFA"
                  render={(props) => {
                    return <LoginExternalMFA {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/login-external/forgot-password"
                  name="Login External - Forgot Password"
                  render={(props) => {
                    return <LoginExternalForgotPassword {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/login-external/reset-password"
                  name="Login External - Reset Password"
                  render={(props) => {
                    return <LoginExternalResetPassword {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/login-external/expired-password"
                  name="Login External - Expired Password"
                  render={(props) => {
                    return <LoginExternalExpiredPassword {...props} />;
                  }}
                />
                <Route
                  exact
                  path="/login-external/personal-details"
                  name="Login External - Personal Details"
                  render={(props) => {
                    return <LoginExternalPersonalDetails {...props} />;
                  }}
                />
                <AuthRoute
                  path="/"
                  name="Home"
                  render={(props) => (
                    <WarehouseProvider>
                      <GlobalSearchProvider>
                        <DefaultLayout {...props} />
                      </GlobalSearchProvider>
                    </WarehouseProvider>
                  )}
                />
              </>
            </Switch>
          </ImageUploaderProvider>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
